<label
	class="cursor-pointer block mb-1 text-sm font-medium text-gray-900 dark:text-white"
	[htmlFor]="key"
	>{{ title }}
	<span
		*ngIf="formGroup.get(key) | controlRequired"
		[ngClass]="{ 'text-warn-600': formGroup.get(key)!.invalid }"
		>*</span
	>
</label>
<div class="">
	<ng-container [formGroup]="formGroup" *ngIf="!scope.loading(); else loading">
		<div>
			<p-password
				class="bg-gray-50 block w-full text-md"
				[id]="key"
				[formControlName]="key"
				[toggleMask]="true"
				[feedback]="false"
				[placeholder]="placeholder"></p-password>
			<div *ngIf="formGroup.get(key)?.dirty || formGroup.get(key)?.touched">
				<div
					class="transition-all duration-400 origin-top"
					[ngClass]="{
						'scale-y-100': formGroup.get(key)!.invalid,
						'scale-y-0': !formGroup.get(key)!.invalid
					}">
					<small class="flex flex-col text-warn-600" *ngIf="formGroup.get(key)?.errors?.required">
						É obrigatório
					</small>
					<small class="flex flex-col text-warn-600" *ngIf="formGroup.get(key)?.errors?.minlength">
						Mínimo {{ formGroup.get(key)?.errors?.minlength.requiredLength }} caractere(s)
					</small>
					<small class="flex flex-col text-warn-600" *ngIf="formGroup.get(key)?.errors?.maxlength">
						Máximo {{ formGroup.get(key)?.errors?.maxlength.requiredLength }} caractere(s)
					</small>
					<small class="flex flex-col text-warn-600" *ngIf="formGroup.get(key)?.errors?.equals">
						A {{ titleFieldEquals | lowercase }} e sua {{ title | lowercase }} devem ser iguais!
					</small>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-template #loading>
		<div>
			<span class="p-input-icon-right">
				<i class="pi pi-spin pi-spinner"></i>
				<input [name]="key" [id]="key" pInputText disabled />
			</span>
		</div>
	</ng-template>
</div>
